import { TransformDate } from '../../../shared/decorators/transform-date.decorator';
import { TransformFloat } from '../../../shared/decorators/transform-float.decorator';
import { ApiRequestFilters } from '../../../shared/types/api-request-filters';
import { RentalReservationRecordCategoryEnum } from '../enums/rental-reservation-record-category.enum';
import { RentalReservationStatusEnum } from '../enums/rental-reservation-status.enum';

/**
 * Rental reservations filters
 */
export class RentalReservationsFilters extends ApiRequestFilters {
  /**
   * Agents id values
   */
  agents?: number[];

  /**
   * Vehicles id values
   */
  vehicles?: number[];

  /**
   * Vehicle categories id values
   */
  vehicleCategories?: number[];

  /**
   * Pickup locations id values
   */
  pickupLocations?: number[];

  /**
   * Drop off locations id values
   */
  dropOffLocations?: number[];

  /**
   * Drivers id values
   */
  drivers?: number[];

  /**
   * Record category values
   */
  recordCategories?: RentalReservationRecordCategoryEnum[];

  /**
   * Status values
   */
  statuses?: RentalReservationStatusEnum[];

  /**
   * Starts at from
   */
  @TransformDate()
  startsAtFrom?: Date;

  /**
   * Starts at to
   */
  @TransformDate()
  startsAtTo?: Date;

  /**
   * Ends at from
   */
  @TransformDate()
  endsAtFrom?: Date;

  /**
   * Ends at to
   */
  @TransformDate()
  endsAtTo?: Date;

  /**
   * Individual dates that are contained within the StartsAt and EndsAt period
   */
  @TransformDate()
  containsDates?: Date[];

  /**
   * Computed total net from
   */
  @TransformFloat()
  computedTotalNetFrom?: number;

  /**
   * Computed total net to
   */
  @TransformFloat()
  computedTotalNetTo?: number;

  /**
   * Computed total gross from
   */
  @TransformFloat()
  computedTotalGrossFrom?: number;

  /**
   * Computed total gross to
   */
  @TransformFloat()
  computedTotalGrossTo?: number;

  /**
   * Tags list
   */
  tags?: string[];
}
